import { createSlice } from "@reduxjs/toolkit"

const initialQuickFilterData = {
    mkptQuickFilter: {
        month: "",
    },
    cpoPlQuickFilter: {
        company: [],
        company_type: "",
        month: "",
    },
    hostInvQuickFilter: {
        status: "",
        month: "",
    },
    payoutLedgerQuickActiveFilters: {
        settlementId: "",
        clientName: ""
    }
}

const payoutsSlice = createSlice({
    name: "payouts",
    initialState: {
        showColumns: [],
        companyActiveFilters: initialQuickFilterData?.mkptQuickFilter,
        cpoPlatformQuickActiveFilers: initialQuickFilterData?.cpoPlQuickFilter,
        hostInvQuickActiveFilers: initialQuickFilterData?.hostInvQuickFilter,
        payoutLedgerQuickActiveFilters: initialQuickFilterData?.payoutLedgerQuickActiveFilters
    },
    reducers: {
        setCompanyActiveFilters: (state, { payload }) => {
            state.companyActiveFilters = payload
        },
        setShowColumns: (state, { payload: { columns } }) => {
            state.showColumns = columns
        },
        setCpoPlatformQuickActiveFilers: (state, { payload }) => {
            state.cpoPlatformQuickActiveFilers = payload
        },
        setHostInvQuickActiveFilers: (state, { payload }) => {
            state.hostInvQuickActiveFilers = payload
        },
        setPayoutLedgerQuickActiveFilters: (state, { payload }) => {
            state.payoutLedgerQuickActiveFilters = payload
        },
    },
})

export const { setShowColumns, setCompanyActiveFilters, setCpoPlatformQuickActiveFilers, setHostInvQuickActiveFilers, setPayoutLedgerQuickActiveFilters } =
    payoutsSlice.actions
export default payoutsSlice.reducer
